import { defineFcm } from '../shared/factory';

export const FCM_GOOGLE_AUTH_USE_IDENTITY_SERVICES = defineFcm('google_auth_use_identity_services')
	.asBoolean()
	.withDefault(false)
	.toConfig();
